
import { useEffect, useRef } from 'react';


import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount, useDisconnect, useSignMessage } from 'wagmi';
import { toast } from 'react-toastify';

const useWalletConnect = (callback) => {

  const { open,close } = useWeb3Modal();
  const isClickButton = useRef(false);
  const { address, isConnected } = useAccount();
  const { signMessage, data, isSuccess } = useSignMessage();
  const { disconnect } = useDisconnect();

  // useEffect(() => {
  //   disconnect();
  // }, []);

  const getMessage = () => {
    // userService.walletMessage({ address }).then((res) => {
    //   signMessage({ message: res.data },{
    //     onError(){
    //       close()
    //     }
    //   });
    // });
  };
  // useEffect(() => {
  //   alert(isIdle + ' ' + isLoading + ' ' + isError + ' ' + variables?.message);
  // }, [isLoading, isIdle, isError]);
  useEffect(() => {
    if (isClickButton.current) {
      getMessage();
    }
  }, [isConnected]);
  const connectWallet = () => {
    if (!isConnected) {
      isClickButton.current = true;
      open({ view:'Connect' });
    } else {
      getMessage();
    }
  };

  const disconnectWallet = () => {
    // userService.walletUnlink().then((res) => {
    //   if (res.success) {
    //     disconnect();

    //   }
    // });
    disconnect();
  };
  // useEffect(() => {
  //   // alert(data)
  //   if (isSuccess && address) {
  //     userService.walletLink({ signature: data, address: address }).then((res) => {
  //       if (res.success) {
    
  //         callback && callback();
  //         toast.success('Success');
  //         disconnect();
  //         close()
  //       } else {
  //         toast.error(res?.error_message);
  //         // disconnect();
  //       }
  //     });
  //   }
  // }, [address, isSuccess]);

  return {
    connectWallet,
    disconnectWallet,

    isUserConnected:isConnected,
    address: address
  };
};

export default useWalletConnect;
